function countLabel(verb, count, singular = 'object', plural = `${singular}s`) {
  return `${verb} ${count} ${count === 1 ? singular : plural}`;
}

const TOOL_NAMES = {
  select: 'Select',
  move: 'Move',
  rotate: 'Rotate',
  scale: 'Scale',
  'box-select': 'Box Select',
};

/**
 * Convert a manual object action into bridge batch entries.
 *
 * `normalisedSelection` is deliberately accepted as-is. The selection model
 * owns parent/child normalization, keeping this pure planner independent from
 * the scene graph and preventing a parent plus its child from being acted on
 * twice.
 */
export function commandsForAction(action, normalisedSelection = [], options = {}) {
  const ids = [...normalisedSelection];

  switch (action) {
    case 'delete':
      return {
        label: countLabel('Delete', ids.length),
        entries: ids.map((id) => ['deleteObject', { id }]),
      };
    case 'duplicate':
      return {
        label: countLabel('Duplicate', ids.length),
        entries: ids.map((id) => ['duplicate', { id, ...(options.offset ? { offset: options.offset } : {}) }]),
      };
    case 'group':
      return {
        label: countLabel('Group', ids.length),
        entries: [['group', { ids }]],
      };
    case 'ungroup':
      return {
        label: countLabel('Ungroup', ids.length, 'group'),
        entries: ids.map((id) => ['ungroup', { id }]),
      };
    case 'mirror': {
      const axis = String(options.axis ?? 'x').toLowerCase();
      const pivot = options.pivot ?? 0;
      return {
        label: `${countLabel('Mirror', ids.length)} on ${axis.toUpperCase()}`,
        entries: ids.map((id) => ['mirror', { id, axis, pivot }]),
      };
    }
    case 'select-all':
      return { label: 'Select All', entries: [] };
    case 'clear-selection':
      return { label: 'Clear Selection', entries: [] };
    case 'frame-selection':
      return { label: 'Frame Selection', entries: [] };
    case 'frame-all':
      return { label: 'Frame All', entries: [] };
    case 'tool': {
      const name = TOOL_NAMES[options.tool] ?? String(options.tool ?? 'Select');
      return { label: `${name} Tool`, entries: [] };
    }
    case 'select-tool':
    case 'move-tool':
    case 'rotate-tool':
    case 'scale-tool':
    case 'box-select': {
      const tool = action === 'box-select' ? action : action.slice(0, -5);
      return { label: `${TOOL_NAMES[tool]} Tool`, entries: [] };
    }
    default:
      throw new Error(`unknown manual action '${action}'`);
  }
}
